// Tab.jsx
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import Text from '../atoms/Text';
import { DataContext } from '@/components/context/DataContext';

const TabItem = ({
    tab, tabsClass, showtab, enableShowTab, count
}) => {
    const isSelected = tab.id === showtab;

    let activeBorderColor = 'border-primary-300';
    let activeTextColor = 'text-primary-300';
    let badgeBgColor = 'bg-primary-300';

    if (tab.theme === 'agy') {
        activeBorderColor = 'border-success-500';
        activeTextColor = 'text-success-500';
        badgeBgColor = 'bg-success-500';
    } else if (tab.theme === 'idb') {
        activeBorderColor = 'border-idb-500';
        activeTextColor = 'text-idb-500';
        badgeBgColor = 'bg-idb-500';
    }

    return (
        <li className={`${tabsClass} border-b ${isSelected ? `${activeBorderColor} ${activeTextColor}` : 'text-gray-200 border-transparent'}`} onClick={() => {
            enableShowTab(tab.id);
        }}>
            <a
                href={tab.href}
                key={tab.title}
                role="tab"
                aria-selected={isSelected}
            >
                <Text
                    variant="bodySmall"
                    fontWeight="font-semibold"
                    className={'select-none py-3 h-[47px] cursor-pointer transform transition-transform px-4 flex items-center justify-center gap-2'}
                >
                    <span>{tab.titleContent || tab.title}</span>
                    {count ? (
                        <span className={`w-[20px] h-4 grid place-content-center text-center text-[10px] font-semibold rounded-full border text-gray-100 ${isSelected ? `${activeBorderColor} ` : ' border-gray-200'}`}>
                            {count}
                        </span>
                    ) : null}
                </Text>
            </a>
        </li>
    );
};

const Tabs = ({
    containerClass, tabsClass, tabs, onClick = () => { }, tabBodyclassname, tabNavClassName
}) => {
    const { matchingCount } = useContext(DataContext);
    const [showtab, setShowtab] = useState(tabs[tabs.findIndex((x) => x.defaultTab) === -1 ? 0 : tabs.findIndex((x) => x.defaultTab)]?.id);

    const enableShowTab = (id) => {
        const tabtoshow = tabs.find((tab) => tab.id === id);
        setShowtab(tabtoshow.id);
        onClick(tabtoshow.value);
        typeof (tabtoshow.onClick) === 'function' && tabtoshow.onClick();
    };

    return (
        <div role="tabpanel">
            <ul
                className={`flex flex-row flex-nowrap overflow-x-auto mb-3 border-b border-gray-400 box-border ${tabNavClassName}`}
                role="tablist"
                aria-label="Tabs Navigation"
            >
                {tabs.map((tab) => (
                    <TabItem key={tab.title} tab={tab} tabsClass={tabsClass} showtab={showtab} enableShowTab={enableShowTab}
                        count={tab.count ?? matchingCount[tab.id]} />
                ))}
            </ul>
            <div className={`${tabBodyclassname || 'px-4'} `} role="tabpanel" aria-labelledby={showtab}>
                {tabs.map((tab) => showtab === tab.id
                    && <div key={tab.id} className={`${containerClass} text-gray-100 `}>
                        {tab.content !== null && tab.content}
                    </div>)}
            </div>
        </div>
    );
};

Tabs.propTypes = {
    containerClass: PropTypes.string,
    tabsClass: PropTypes.string,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            title: PropTypes.string,
            content: PropTypes.node,
            value: PropTypes.node
        })
    ),
    onClick: PropTypes.func,
    tabId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tabBodyclassname: PropTypes.string,
    tabNavClassName: PropTypes.string
};

export default Tabs;
